import { formatDateTime } from '@seen/core/dates'
import type * as appointments from '@seen/core/models/appointments/index'

import { Badge, cn } from '@seen/ui'
import { IconCalendarEvent, IconCalendarX } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { AppointmentLink } from '#src/pages/participants/timeline/AppointmentLink.tsx'

export function AppointmentBadge({
  appointment,
}: {
  appointment: appointments.ExtendedAppointment
}): JSX.Element {
  return (
    <AppointmentLink
      appointment={appointment}
      className={cn(
        'w-fit decoration-foreground-secondary',
        appointment.isCancelled && 'line-through'
      )}
    >
      <Tooltip>
        <TooltipTrigger>
          <Badge
            variant="outline"
            className="flex w-fit max-w-fit items-center gap-1"
          >
            {appointment.isCancelled ? (
              <IconCalendarX size={16} />
            ) : (
              <IconCalendarEvent size={16} />
            )}
            {appointment.start && formatDateTime(appointment.start)}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>{appointment.title ?? 'Appointment'}</TooltipContent>
      </Tooltip>
    </AppointmentLink>
  )
}
